import React from "react";
import { CommonGrid } from "styledComponents/common";

import { DashBoardCommonGrid } from "../../DashBoardNew/dashBoardNewStyles";
import HourlyEstimatedVsCompletedChart from "./HourlyEstimatedVsCompletedChart";
import RecentCompletedJobsSection from "./RecentCompletedJobsSection";
import TopCustomers from "./TopCustomers";

const DashBoardFourthSection = ({
  getDashboardEstimation,
  estimationIsLoading,
  estimationData,
  getDashboardTopCustomers,
  topCustomersIsLoading,
  topCustomers,
  selectedOrganization,
  history,
  getDashboardRecentCompletedJobs,
  recentCompletedJobsIsLoading,
  recentCompletedJobsData,
}) => {
  const orgType = selectedOrganization?.type || "operation";
  const isOperationType = orgType === "operation";
  return (
    <DashBoardCommonGrid
      responsiveBreakpoint="920px"
      responsiveColumns="1fr"
      columns="1fr 1fr"
      gap="20px"
    >
      <CommonGrid columns="1fr" gap="20px">
        <HourlyEstimatedVsCompletedChart
          getDashboardEstimation={getDashboardEstimation}
          estimationIsLoading={estimationIsLoading}
          estimationData={estimationData}
          selectedOrganization={selectedOrganization}
        />
      </CommonGrid>
      <CommonGrid columns="1fr" gap="20px">
        {!isOperationType ? (
          <TopCustomers
            getDashboardTopCustomers={getDashboardTopCustomers}
            topCustomersIsLoading={topCustomersIsLoading}
            topCustomers={topCustomers}
            selectedOrganization={selectedOrganization}
          />
        ) : (
          <RecentCompletedJobsSection
            history={history}
            selectedOrganization={selectedOrganization}
            getDashboardRecentCompletedJobs={getDashboardRecentCompletedJobs}
            recentCompletedJobsIsLoading={recentCompletedJobsIsLoading}
            recentCompletedJobsData={recentCompletedJobsData}
          />
        )}
      </CommonGrid>
    </DashBoardCommonGrid>
  );
};

export default DashBoardFourthSection;
